$(document).ready(function(){
	//Best sellers slider
	//    $('.sec-hmtestimonial .testimonial-ul').slick({
  //     arrows: true,
  //     dots: false,
  //     slidesToShow: 3,
  //     slidesToScroll: 1,
  //     horizontal: true,
  //     infinite: true,
  //     autoplay: false,
  //     pauseOnHover: false,
  //     autoplaySpeed: 3000,
  //     responsive: [
  //     {
  //       breakpoint: 1200,
  //       settings: {
  //         slidesToShow: 2
  //       }
  //     },
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 1
  //       }
  //     }
  //     ]
  // });
});
function applyJQueryBasedOnScreenSize() {
   const mediaQuery = window.matchMedia("(max-width: 1439px)");

   //alert('TEST');

   if (mediaQuery.matches) {
  	$('.sec-hmtestimonial .testimonial-ul').slick({
		   arrows: true,
       dots: false,
       slidesToShow: 3,
       slidesToScroll: 1,
       horizontal: true,
       infinite: true,
       autoplay: true,
       pauseOnHover: false,
       autoplaySpeed: 3000,
		   responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },

        }
		  ]
	});

				
   } else {

     // If you initialized a plugin, you might need to destroy it:
     if (
       $(".sec-hmtestimonial .testimonial-ul").hasClass("slick-initialized")
     ) {
       $(".sec-hmtestimonial .testimonial-ul").slick("unslick");
     }
   }
 }

 // 1. Initial check when the document is ready
 applyJQueryBasedOnScreenSize();

 let resizeTimeout;
 $(window).on("resize", function() {
   clearTimeout(resizeTimeout);
   resizeTimeout = setTimeout(applyJQueryBasedOnScreenSize, 200); // Adjust debounce time as needed
 });